export const sessionCheck = {
    checkIn: 1,
    checkOut: -1
};

export const sessionPingInterval = 30000;
export const acceptableDelta = 3000;

export const PROD_APP_ID = 'webattendee';
export const PROD_ENV = 'prod';
import {
    SESSIONS_TAB_ALL,
    SESSIONS_TAB_FAVOURITES,
    SESSIONS_TAB_REGISTRATIONS
} from './Enums';

export const buttonTypes = {
    login: 'LOGIN',
    register: 'REGISTER',
    markInterest: 'MARK INTEREST',
    addCalendar: 'ADD TO CALENDAR',
    saveSeat: 'SAVE A SEAT',
    agendaTabButtons: 'AGENDA TAB BUTTONS',
    agendaFilterTag: 'AGENDA FILTER TAG',
    liveSessionButton: 'JOIN LIVE SESSION BUTTON',
    watchOnDemandButton: 'WATCH ON DEMAND BUTTON',
    rateSession: 'RATE SESSION',
    feedbackSession: 'FEEDBACK SESSION',
    likeSpeaker: 'LIKE SPEAKER',
    nextSendEmailButton: 'NEXT ON SEND MAGIC LINK TO USER EMAIL',
    backButton: 'BACK BUTTON',
    onBoardingBanner: 'GO_TO_VIA_ONBOARDING_BANNER',
    clapping: 'CLAPPING_REACTION',
    sessionAssetDownloaded: 'SESSION_ASSET_DOWNLOADED'
};

export const loginSubCategory = {
    agendaGeneralLogin: 'AGENDA LOGIN',
    loginTooltip: 'LOGIN TOOLTIP',
    loginAgendaNewFlow: 'WEB LOGIN AGENDA',
    loginModalNewFlow: 'MODAL LOGIN-REGISTER',
    loginTooltipNewFlow: 'TOOLTIP EMBEDDED AGENDA LOGIN-REGISTER',
    loginRestrictionButton: 'LOGIN ON LIVE BROADCAST SESSION VIEW',
    accessErrorBanner: 'LOGIN ON SESSION ACCESS ERROR BANNER'
};

export const registerSubCategory = {
    loginPopover: 'REGISTER ON LOGIN POPOVER',
    registerModalNewFlow: 'MODAL LOGIN-REGISTER',
    registerTooltipNewFlow: 'TOOLTIP EMBEDDED AGENDA LOGIN-REGISTER',
    registerRestrictionButton: 'REGISTER ON LIVE BROADCAST SESSION VIEW',
    accessErrorBanner: 'REGISTER ON SESSION ACCESS ERROR BANNER'
};

export const interestSubCategory = {
    markAsInterests: 'MARK AS INTEREST',
    markAsNotInterests: 'MARK AS NOT INTERESTS'
};

export const saveASeatSubCategory = {
    register: 'REGISTERED ON SESSION',
    notRegistered: 'NOT REGISTERED ON SESSION',
    disabled: 'DISABLED REGISTER ON SESSION',
    chairIcon: 'CHAIR ICON ON AGENDA',
    singleSaveASeatPopUp: 'SAVE A SEAT WITH SINGLE TICKET POP UP',
    multipleSaveASeatPopUp: 'SAVE A SEAT WITH MULTIPLE TICKET POP UP',
    removeSingleSaveASeatPopUp: 'REMOVE A SEAT WITH SINGLE TICKET POP UP',
    removeMultipleSaveASeatPopUp: 'REMOVE A SEAT WITH MULTIPLE TICKET POP UP'
};

export const agendaTabButtonSubCategory = {
    [SESSIONS_TAB_ALL]: 'ALL SESSIONS TAB',
    [SESSIONS_TAB_FAVOURITES]: 'MY INTERESTS TAB',
    [SESSIONS_TAB_REGISTRATIONS]: 'MY REGISTERED SESSIONS TAB'
};

export const rateSessionSubCategory = {
    clickRateOnPage: 'CLICK RATE BUTTON ON AGENDA',
    setActualSessionRate: 'SET CURRENT RATE FOR SESSION',
    submitRateFeedbackForm: 'CLICK SUBMIT SESSION RATE FEEDBACK FORM'
};

export const watchOnDemandSubCategory = 'PLAY ICON';

export const addCalendarSubCategory = 'TRIGGER POPUP APPEARING';

export const nextButtonSubcategory = {
    nextOnOldFlow: 'NEXT BUTTON OLD FLOW',
    nextOnNewFlow: 'NEXT BUTTON NEW FLOW'
};

export const WAKE_UP_AFTER_SLEEP = 'WAKE_UP_AFTER_SLEEP';

export const TICKET_ENTITY_VALIDATION_LOG = 'TICKET_ENTITY_VALIDATION_LOG';

export const systemInfo = {
    ELEMENT_LOADED: 'ELEMENT_LOADED'
};

export const bannerSubcategory = 'EMAIL_VERIFICATION';

export const engagementControlsSubCategory = {
    gotIt: 'GOT_IT',
    clickClap: 'CLICK_CLAP',
    spaceClap: 'SPACE_CLAP',
    mute: 'MUTE',
    unmute: 'UNMUTE',
    volumeUp: 'VOLUME_CHANGE_UP',
    volumeDown: 'VOLUME_CHANGE_DOWN'
};
